"use client";

import { c as _c } from "react/compiler-runtime";
import XIcon from "public/assets/footerIcons/x.svg";
import FacebookIcon from "public/assets/footerIcons/facebook.svg";
import LinkedinIcon from "public/assets/footerIcons/linkedin.svg";
import InstagramIcon from "public/assets/footerIcons/instagram.svg";
import PinterestIcon from "public/assets/footerIcons/pinterest.svg";
import RedditIcon from "public/assets/footerIcons/reddit.svg";
import QuoraIcon from "public/assets/footerIcons/quora.svg";
import YoutubeIcon from "public/assets/footerIcons/youtube.svg";
import Link from "next/link";
import { cx } from "lib/cx";
import Image from "next/image";
import { trackReferralFooter } from "lib/analytics";
import { ChatBubbleLeftRightIcon, DocumentTextIcon, EnvelopeIcon, PencilIcon, PencilSquareIcon, CurrencyDollarIcon, UserGroupIcon } from "@heroicons/react/24/outline";
export const Footer = () => {
  const $ = _c(26);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="relative h-[92px] w-[85px] lg:h-[97px] lg:w-[90px] xl:h-[107px] xl:w-[100px] 2xl:h-[127px] 2xl:w-[120px]"><Image src="/assets/resumemateFooterLogo.svg" alt="ResumeMate" fill={true} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="text-[#1C75BC]">Resume</span>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="space-y-4"><div className="mx-auto flex w-fit items-center gap-1 md:mx-0 lg:gap-2">{t0}<div className="font-montserrat text-[10px] font-semibold leading-3 md:text-xs md:leading-3 lg:text-xs lg:leading-3 xl:text-sm xl:leading-4 2xl:text-base 2xl:leading-4">{t1} <br /><span className="text-[#27AAE1]">Mate.io</span></div></div><p className="text-sm text-gray-600 max-md:mx-auto max-md:w-[80%] lg:w-full lg:text-base">Craft your perfect resume with our professional tools and services.</p></div>;
    t3 = <h3 className="mb-4 text-lg font-semibold text-gray-900">Services</h3>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <li><Link href="/resume-builder" className="flex items-center gap-2 text-gray-600 hover:text-[#1C75BC] max-md:justify-center"><DocumentTextIcon className="h-4 w-4" /> Templates</Link></li>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <li><Link href="/resume-builder" className="flex items-center gap-2 text-gray-600 hover:text-[#1C75BC] max-md:justify-center"><PencilIcon className="h-4 w-4" /> Resume Builder</Link></li>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <li><Link href="/upload-resume" className="flex items-center gap-2 text-gray-600 hover:text-[#1C75BC] max-md:justify-center"><Image className="" src="/icons/checkScoreBlack.svg" alt="score check icon" width={15} height={15} loading="lazy" />{" "}Score-check</Link></li>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <li><Link href="/affiliate" className="flex items-center gap-2 text-gray-600 hover:text-[#1C75BC] max-md:justify-center"><CurrencyDollarIcon className="h-4 w-4" />Affiliate Marketing</Link></li>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <li><Link href="/referral" onClick={_temp} className="flex items-center gap-2 text-gray-600 hover:text-[#1C75BC] max-md:justify-center"><UserGroupIcon className="h-4 w-4" />Referral Program</Link></li>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <li><Link href="/resume-writing" className="flex items-center gap-2 text-gray-600 hover:text-[#1C75BC] max-md:justify-center"><PencilSquareIcon className="h-4 w-4" /> Resume Writing</Link></li>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  let t11;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div>{t3}<ul className="space-y-3">{t4}{t5}{t6}{t7}{t8}{t9}<li><Link href="https://wa.me/918618147607" className="flex items-center gap-2 text-gray-600 hover:text-[#1C75BC] max-md:justify-center"><ChatBubbleLeftRightIcon className="h-4 w-4" /> Consult Now for Free</Link></li></ul></div>;
    t11 = <h3 className="mb-4 text-lg font-semibold text-gray-900">Legal</h3>;
    $[10] = t10;
    $[11] = t11;
  } else {
    t10 = $[10];
    t11 = $[11];
  }
  let t12;
  let t13;
  let t14;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <li><Link href="/privacy-policy" className="text-gray-600 hover:text-[#1C75BC]">Privacy Policy</Link></li>;
    t13 = <li><Link href="/refund-policy" className="text-gray-600 hover:text-[#1C75BC]">Refund Policy</Link></li>;
    t14 = <li><a href="/terms-and-conditions" className="text-gray-600 hover:text-[#1C75BC]">{"Terms & Conditions"}</a></li>;
    $[12] = t12;
    $[13] = t13;
    $[14] = t14;
  } else {
    t12 = $[12];
    t13 = $[13];
    t14 = $[14];
  }
  let t15;
  let t16;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div>{t11}<ul className="space-y-3">{t12}{t13}{t14}<li><Link href="mailto:help@resumemate.io" className="flex items-center gap-2 text-gray-600 hover:text-[#1C75BC] max-md:justify-center"><EnvelopeIcon className="h-4 w-4" /> help@resumemate.io</Link></li></ul></div>;
    t16 = <h3 className="mb-4 text-lg font-semibold text-gray-900">Connect With Us</h3>;
    $[15] = t15;
    $[16] = t16;
  } else {
    t15 = $[15];
    t16 = $[16];
  }
  let t17;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Link href="https://x.com/resume_mate" target="_blank"><XIcon className={cx("h-auto w-[18px] lg:w-[21px] xl:w-[26px] 2xl:w-[31px]")} /></Link>;
    $[17] = t17;
  } else {
    t17 = $[17];
  }
  let t18;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <Link href="https://www.linkedin.com/company/resume-mate/" target="_blank"><LinkedinIcon className={cx("h-auto w-[18px] lg:w-[21px] xl:w-[26px] 2xl:w-[31px]")} /></Link>;
    $[18] = t18;
  } else {
    t18 = $[18];
  }
  let t19;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Link href="https://www.instagram.com/resumemate.io/" target="_blank"><InstagramIcon className={cx("h-auto w-[18px] lg:w-[21px] xl:w-[26px] 2xl:w-[31px]")} /></Link>;
    $[19] = t19;
  } else {
    t19 = $[19];
  }
  let t20;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <Link href="https://www.youtube.com/@resumemate" target="_blank"><YoutubeIcon className={cx("h-auto w-[18px] lg:w-[21px] xl:w-[26px] 2xl:w-[31px]")} /></Link>;
    $[20] = t20;
  } else {
    t20 = $[20];
  }
  let t21;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <Link href="https://www.facebook.com/profile.php?id=61566772433189" target="_blank"><FacebookIcon className={cx("h-auto w-[18px] lg:w-[21px] xl:w-[26px] 2xl:w-[31px]")} /></Link>;
    $[21] = t21;
  } else {
    t21 = $[21];
  }
  let t22;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <Link href="https://www.pinterest.com/resumemate/" target="_blank"><PinterestIcon className={cx("h-auto w-[18px] lg:w-[21px] xl:w-[26px] 2xl:w-[31px]")} /></Link>;
    $[22] = t22;
  } else {
    t22 = $[22];
  }
  let t23;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <Link href="https://www.reddit.com/r/ResumeBuildersHub/?rdt=34063" target="_blank"><RedditIcon className={cx("h-auto w-[18px] lg:w-[21px] xl:w-[26px] 2xl:w-[31px]")} /></Link>;
    $[23] = t23;
  } else {
    t23 = $[23];
  }
  let t24;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <div className="grid grid-cols-1 gap-8 max-md:text-center md:grid-cols-2 lg:grid-cols-4">{t2}{t10}{t15}<div>{t16}<div className="grid grid-cols-4 gap-4 max-md:justify-items-center">{t17}{t18}{t19}{t20}{t21}{t22}{t23}<Link href="https://resumemate.quora.com/" target="_blank"><QuoraIcon className={cx("h-auto w-[18px] lg:w-[21px] xl:w-[26px] 2xl:w-[31px]")} /></Link></div></div></div>;
    $[24] = t24;
  } else {
    t24 = $[24];
  }
  let t25;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <footer className="bg-white pb-8 pt-12 shadow-[0_-2px_7px_-1px_rgba(0,0,0,0.1)]"><div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">{t24}<div className="mt-12 border-t border-gray-200 pt-8"><p className="text-center text-sm text-gray-500">© {new Date().getFullYear()} Resumemate. All rights reserved.</p></div></div></footer>;
    $[25] = t25;
  } else {
    t25 = $[25];
  }
  return t25;
};
function _temp() {
  return trackReferralFooter();
}